import { defineMessages } from 'react-intl';

export const scarcityMessages = defineMessages({
  text: {
    id: 'scarcity.text',
    defaultMessage: 'Fast ausverkauft',
  },
});
